
import { Component, Vue } from 'vue-property-decorator'
import error401 from '@/assets/images/error-page/error-401.svg'
import errorContent from './error-content.vue'

@Component({
    components: {
        errorContent
    }
})
export default class Error401 extends Vue {
    name = 'error_401'
    src = error401
}
